module.exports = __webpack_public_path__ + "img/bg_start.06c9f5f9.jpeg";